import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["src"]

import { useUiStore } from '@/stores/ui';
import { useProgramsStore } from '@/stores/programs';
import { useDialogStore } from '@/stores/dialogs';
import skolkovoLogo from '@/assets/skolkovo-logo.png'
import AddProgramDialog from './dialogs/AddProgramDialog.vue';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAccountStore } from '@/stores/account';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheDrawer',
  setup(__props) {

const programsStore = useProgramsStore()
const uiStore = useUiStore()
const dialogStore = useDialogStore()
const accountStore = useAccountStore()

const router = useRouter()
const innerPage = computed(() => {
  if (router.currentRoute.value.name === "roadmap") return "/roadmap"
  return ""
})

const addProgram = () => {
  dialogStore.open(AddProgramDialog)
}

const onLinkClick = (e: MouseEvent, program: any) => {
  if (router.currentRoute.value.path.startsWith("/programs") && router.currentRoute.value.name) {
    e.preventDefault()
    router.push({ name: router.currentRoute.value.name, params: { programId: program.id } })
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    modelValue: _unref(uiStore).drawer,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(uiStore).drawer) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_btn, {
        variant: "text",
        icon: "mdi-chevron-double-left",
        class: "close-icon rounded-circle",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(uiStore).drawer = false))
      }),
      _createElementVNode("img", {
        src: _unref(skolkovoLogo),
        height: "36",
        class: "ml-5 mt-5",
        alt: "skolkovo logo"
      }, null, 8, _hoisted_1),
      _createVNode(_component_v_list, { class: "mt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_group, null, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_list_item, _mergeProps(props, {
                title: "Программы",
                "prepend-icon": "mdi-filter-variant"
              }), null, 16)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(programsStore).programs, (program) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  title: program.name,
                  to: '/programs/'+program.id,
                  onClick: ($event: any) => (onLinkClick($event, program))
                }, null, 8, ["title", "to", "onClick"]))
              }), 256)),
              (_unref(accountStore).isDirector)
                ? (_openBlock(), _createBlock(_component_v_list_item, {
                    key: 0,
                    "prepend-icon": "mdi-plus",
                    title: "Добавить программу",
                    link: "",
                    onClick: addProgram
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_unref(accountStore).isSupervisor && !_unref(accountStore).isDirector)
            ? (_openBlock(), _createBlock(_component_v_list_group, { key: 0 }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_list_item, _mergeProps(props, {
                    title: "Супервизия",
                    "prepend-icon": "mdi-content-paste"
                  }), null, 16)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(programsStore).programs, (item) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      title: item.name,
                      to: '/supervising/'+item.id
                    }, null, 8, ["title", "to"]))
                  }), 256))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(accountStore).isDirector)
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 1,
                title: "Трекеры",
                to: "/trackers",
                "prepend-icon": "mdi-account-cog"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_list_item, {
            title: "Обратная связь",
            to: "/feedback",
            "prepend-icon": "mdi-chat-processing-outline"
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})